(() => {
  'use strict';
  let sheet, opener, busy = false, closeTimer;
  const init = () => { sheet = document.querySelector('[data-lp-cart-sheet]'); };
  const root = () => sheet.dataset.root || '/';
  const error = (message) => {
    const node = sheet.querySelector('[data-lp-cart-error]');
    if (node) { node.textContent = message || sheet.dataset.error; node.hidden = false; }
  };
  const setBusy = (value) => {
    busy = value;
    sheet.setAttribute('aria-busy', String(value));
    sheet.querySelectorAll('[data-lp-cart-change], [name=checkout]').forEach(button => { button.disabled = value; });
  };
  const updateCount = (count) => {
    document.querySelectorAll('[data-lp-cart-open]').forEach(link => {
      let badge = link.querySelector('.lp-cart__count');
      if (count > 0) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'lp-cart__count'; badge.setAttribute('aria-hidden', 'true'); link.append(badge); }
        badge.textContent = count;
      } else if (badge) badge.remove();
    });
  };
  const refresh = async () => {
    const url = new URL(root(), location.origin);
    url.searchParams.set('section_id', 'lp-cart-sheet');
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(sheet.dataset.error);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const next = doc.querySelector('[data-lp-cart-content]');
    const nextSheet = doc.querySelector('[data-lp-cart-sheet]');
    if (!next || !nextSheet) throw new Error(sheet.dataset.error);
    const previous = document.activeElement;
    const wasInside = sheet.contains(previous);
    const previousKey = previous?.dataset.lpCartChange;
    const previousQty = previous?.dataset.quantity;
    sheet.querySelector('[data-lp-cart-content]').replaceWith(next);
    sheet.dataset.count = nextSheet.dataset.count;
    updateCount(Number(sheet.dataset.count));
    if (wasInside) {
      const match = Array.from(sheet.querySelectorAll('[data-lp-cart-change]')).find(button => button.dataset.lpCartChange === previousKey && button.dataset.quantity === previousQty);
      (match || sheet.querySelector('[data-lp-cart-close]')).focus();
    }
  };
  const open = () => {
    if (!sheet.open) {
      opener = document.activeElement;
      clearTimeout(closeTimer);
      sheet.showModal();
      document.body.classList.add('lp-cart-is-open');
      requestAnimationFrame(() => requestAnimationFrame(() => sheet.classList.add('is-open')));
    }
  };
  const close = () => {
    sheet.classList.remove('is-open');
    closeTimer = setTimeout(() => {
      sheet.close();
      document.body.classList.remove('lp-cart-is-open');
      if (opener?.isConnected) opener.focus();
    }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 260);
  };
  const mutate = async (endpoint, payload) => {
    const response = await fetch(root() + 'cart/' + endpoint + '.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload)
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || sheet.dataset.error);
    await refresh();
  };
  document.addEventListener('click', async event => {
    if (!sheet) init();
    if (!sheet || typeof sheet.showModal !== 'function' || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target.closest('a, button');
    if (target?.matches('[data-lp-cart-open]')) {
      event.preventDefault(); open();
      if (!busy) { setBusy(true); try { await refresh(); } catch (err) { error(err.message); } finally { setBusy(false); } }
      return;
    }
    if (target?.matches('[data-lp-cart-close]')) { if (target.tagName === 'BUTTON') event.preventDefault(); close(); return; }
    if (event.target === sheet) {
      const rect = sheet.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      return;
    }
    if (target?.matches('[data-lp-cart-change]')) {
      event.preventDefault(); if (busy) return;
      setBusy(true);
      try { await mutate('change', { id: target.dataset.lpCartChange, quantity: Number(target.dataset.quantity) }); }
      catch (err) { error(err.message); }
      finally { setBusy(false); }
      return;
    }
    if (target?.tagName === 'A') {
      const url = new URL(target.href, location.origin);
      const match = url.pathname.match(/\/cart\/(\d+):(\d+)\/?$/);
      if (url.origin === location.origin && match) {
        event.preventDefault(); if (busy) return;
        open(); setBusy(true);
        target.setAttribute('aria-busy', 'true');
        try { await mutate('add', { items: [{ id: match[1], quantity: Number(match[2]) }] }); }
        catch (err) { error(err.message); }
        finally { setBusy(false); target.removeAttribute('aria-busy'); }
      }
    }
  });
  document.addEventListener('cancel', event => { if (event.target === sheet) { event.preventDefault(); close(); } }, true);
  document.addEventListener('bm:cart-added', async function () { if (!sheet) init(); open(); try { await refresh(); } catch (err) { error(err.message); } });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('DOMContentLoaded', init);
  init();
})();
